module.exports = __webpack_public_path__ + "static/media/PersoOrange.7f4f835e.png";